import { Box, Tag, useToggle } from '@factorialco/deprecated-design-system'
import { TrainingsTrainingMembershipStatusEnum } from 'generated/resources/graphql'

import { AttendanceTooltip } from 'modules/trainings/components/Revamp/AttendanceTooltip'
import { useTrainingsDatatable } from 'modules/trainings/hooks/useTrainingsDatatable'

type Props = {
  status: TrainingsTrainingMembershipStatusEnum
}

export const TrainingMembershipStatusTag = ({ status }: Props) => {
  const mapTrainingAttendanceStatus = (attendanceStatus: TrainingsTrainingMembershipStatusEnum) => {
    switch (attendanceStatus) {
      case 'completed':
      case 'notstarted':
      case 'started':
      case 'partiallycompleted':
      case 'missing':
      case 'notassigned':
        return attendanceStatus
      default:
        return 'notstarted'
    }
  }
  const { getTrainingAttendanceColor, getTrainingAttendanceTranslation } = useTrainingsDatatable()
  const [hover, setHover] = useToggle()

  return (
    <Box>
      <Box width="fit-content">
        <AttendanceTooltip
          open={hover}
          status={mapTrainingAttendanceStatus(status)}
          toggle={setHover}
        >
          <Tag type={getTrainingAttendanceColor(mapTrainingAttendanceStatus(status))}>
            {getTrainingAttendanceTranslation(mapTrainingAttendanceStatus(status))}
          </Tag>
        </AttendanceTooltip>
      </Box>
    </Box>
  )
}
